import { animated, SpringValue } from 'react-spring'

interface ICurriculumKlassProgressbarProps {
  rate: number
  progress: SpringValue<number>
}

const CurriculumKlassProgressbar = ({ rate, progress }: ICurriculumKlassProgressbarProps) => {
  return (
    <div className="flex flex-1 flex-row items-center gap-2 lg:gap-3">
      <div className="h-2 w-full rounded-3xl bg-alternative">
        <div
          className="h-full rounded-3xl bg-primary-normal"
          style={{ width: `${rate}%`, transition: 'width 1s ease-in-out' }}
        ></div>
      </div>
      <span className="text-sm font-semibold text-primary-normal">
        <animated.span>{progress.to(n => Math.floor(n))}</animated.span>%
      </span>
    </div>
  )
}

export default CurriculumKlassProgressbar
